<template>
    <Header
        :page-title="title"
    ></Header>
    <pageTool></pageTool>
    <div class="page-content cus-content">
        <div class="content">
            <div class="content-info">
                <div class="content-img">
                    <img :src="data.internalInstance.appContext.config.globalProperties.$imgUrl + data.imgUrl">
                </div>
                <div class="content-text">
                    <p class="content-title">{{ data.title }}</p>
                    <p class="content-t"><span>服务品种：</span><span>{{ data.services }}</span></p>
                    <p class="content-t"><span>服务类型：</span><span>{{ data.subjectType }}</span></p>
                    <p class="content-t"><span>联系电话：</span><span>{{ data.contactsPhone }}</span></p>
<!--                    <p class="content-t"><span>农机数量：</span><span>30台</span></p>-->
                    <p class="content-t"><span>所在地址：</span><span>{{ data.address }}</span></p>
                </div>
            </div>
            <div class="content-details">{{ data.subjectMsg }}</div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import pageTool from '@/components/nav/pageTool'
import { onMounted, reactive, getCurrentInstance } from 'vue'
import {useRoute} from "vue-router"
import { getDetail } from '@/api/directories'
const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "DirectoryDetails",
    setup() {
        const route = useRoute()
        const title = {
            cn: '名录库详情',
            en: 'DIRECTORY INFO',
            hasSearch: false,
            titleStyle: false,
            banner
        }
        const data = reactive({
            title: '',
            services: '',
            subjectType: '',
            contactsPhone: '',
            address: '',
            subjectMsg: '',
            imgUrl: '',
            internalInstance: getCurrentInstance()
        })
        const initData = async(id) => {
            const res = await getDetail(id)
            data.title = res.subjectName
            data.services = res.services
            data.subjectType = res.subjectType.desc
            data.contactsPhone = res.contactsPhone
            data.address = res.town ? res.town.desc : ' ' + data.address
            data.subjectMsg = res.subjectMsg
            data.imgUrl = res.subjectLogo
        }
        onMounted(() => {
            initData(route.query.id)
        })
        return {
            title,
            data,
            initData
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
    .cus-content {
        .content {
            width 100%
            padding 12px
            background-color #FFF
            box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
            .content-details {
                width 100%
                padding 5px 10px
                margin-top 5px
                border 1px solid #44A73D
                font-size 12px
                color #575757
                text-indent 24px
            }
            .content-info {
                width 100%
                display flex
                justify-content space-between
                flex-wrap nowrap
                .content-img {
                    width 140px
                    height 140px
                    overflow hidden
                    background-color #F3F3F3
                }
                .content-img img {
                    width 100%
                }
                .content-text {
                    width calc(100% - 140px)
                    padding 0 7px
                    .content-title {
                        color #575757
                        font-size 14px
                        font-weight bolder
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    }
                    .content-t {
                        font-size 12px
                    }
                    .content-t span:first-child {
                        font-weight bolder
                    }
                }
            }
        }
    }
</style>